import Outlet from "@/common/Outlet";
import ErrorPage from "@/pages/_error";
import { FormattedMessage } from "react-intl";
import Forum from "@/components/Forum";
import { Container } from "@/components/Container";
import { HeaderContainer } from "@/components/HeaderContainer";
import { graphql, Environment } from "react-relay";
import { LoaderArgs } from "@/utils/route";
import { ForumScaffoldQuery as ForumScaffoldQueryType } from "./__generated__/ForumScaffoldQuery.graphql";
import { preload, usePreloaded } from "@/utils/relay";
export default function ForumScaffold() {
  const {
    query: { forumBySlug: forum },
  } = useForumScaffoldQuery();
  if (!forum) {
    return (
      <ErrorPage status={404}>
        <FormattedMessage defaultMessage="Discussion not found." />
      </ErrorPage>
    );
  }
  return (
    <div>
      <HeaderContainer>
        <div className="pb-6">
          <Forum forum={forum} />
        </div>
      </HeaderContainer>
      <Container>
        <Outlet />
      </Container>
    </div>
  );
}
const ForumScaffoldQuery = graphql`
  query ForumScaffoldQuery($slug: String!) {
    forumBySlug(slug: $slug) {
      id
      ...ForumFragment
    }
  }
`;
export const loader = (environment: Environment) => {
  return ({ params: { slug } }: LoaderArgs) => {
    if (!slug) {
      throw new Response("No slug", { status: 500 });
    }
    return preload<ForumScaffoldQueryType>(environment, ForumScaffoldQuery, {
      slug,
    });
  };
};
const useForumScaffoldQuery = () => usePreloaded<ForumScaffoldQueryType>();
